import React, { useEffect, useState } from "react";
import { Row, Col, Card, Table, Select, Form, Divider, Tag } from "antd";
import { ExclamationCircleOutlined, ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import moment from "moment";

import api from "../../services/api";
import { FormatarQuantidade, FormatNumber } from "../../ValueObjects";
import { isObjetoDiffVazio } from "../../services/funcoes";

export default function TabVendaEntregaFutura({ form, dadosCliente, dataInicial, dataFinal }) {

    const [notasRemessaVef, setNotasRemessaVef] = useState([]);
    const [notasVef, setnotasVef] = useState([]);
    const [produtoEntregar, setProdutoEntregar] = useState([]);
    const [produtoEntregarNotaFiscal, setProdutoEntregarNotaFiscal] = useState([]);


    useEffect(() => {
        if (!!dadosCliente && isObjetoDiffVazio(dadosCliente)) {
            carregarDados();
        }
    }, [dadosCliente]);

    // useEffect(() => {
    //     carregarDados();
    // }, [dataInicial]);

    // useEffect(() => {
    //     carregarDados();
    // }, [dataFinal]);

    function carregarDados() {
        listarItensVef();
        listarItensNotasVef();
    };




    function listarItensVef() {
        api.get(`ControleVendaEntregaFutura/BuscarProdutosClienteEntregarCRM?IdPessoa=${dadosCliente.pes_id}`).then(
            res => {
                setProdutoEntregar(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        );
    };
    function listarItensNotasVef() {
        api.get(`ControleVendaEntregaFutura/BuscarProdutosClienteEntregarNotaCRM?IdPessoa=${dadosCliente.pes_id}`).then(
            res => {
                setProdutoEntregarNotaFiscal(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        );
    };

    return (
        <div>
            <Row gutter={[0, 24]}>
                <Col span={24}>
                    <Card size="default" title="Saldo de Produtos a Entregar" className="lista-resumo">
                        <Row align="middle" justify="end" gutter={[0, 8]}>
                            <Col span={24}>
                                <Table dataSource={produtoEntregar} columns={[
                                    {
                                        title: 'Código',
                                        width: 50,
                                        align: 'center',
                                        render: ({ pro_codigo }) => (
                                            <div>
                                                <Tag color="processing" className="w-100">
                                                    <b>{pro_codigo}</b>
                                                </Tag>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Descrição Produto',
                                        width: 450,
                                        align: 'left',
                                        render: ({ pro_descricao }) => (
                                            <div>
                                                <b>{pro_descricao}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Un. Medida',
                                        width: 10,
                                        align: 'center',
                                        render: ({ ump_id }) => (
                                            <div>
                                                <b>{ump_id}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Saldo Entregar',
                                        width: 120,
                                        align: 'right',
                                        render: ({ qtdeEntregar, ump_casasdecimais }) => (
                                            <div>
                                                <b>{FormatarQuantidade(qtdeEntregar, ump_casasdecimais)}</b>
                                            </div>
                                        ),
                                    },
                                ]} locale={{
                                    emptyText: (
                                        <Row>
                                            <Col span={24} className="p-t-b-8">
                                                <Divider orientation="center">
                                                    <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                                </Divider>
                                            </Col>
                                        </Row>
                                    )
                                }} scroll={{ x: 900 }} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <Row gutter={[0, 24]} className="lista-resumo m-t-16">
                <Col span={24}>
                    <Card size="default" title="Saldo de Produtos Por Nota de Venda Entrega Futura" className="lista-resumo">
                        <Row align="middle" justify="end" gutter={[0, 8]}>
                            <Col span={24}>
                                <Table dataSource={produtoEntregarNotaFiscal} columns={[
                                {
                                        title: 'Nº Nota',
                                        width: 120,
                                        align: 'center',
                                        render: ({ ntf_numero }) => (
                                            <div>
                                                <Tag color="processing" className="w-100">
                                                    <b>{ntf_numero}</b>
                                                </Tag>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Série',
                                        width: 120,
                                        render: ({ ser_serie }) => (
                                            <div>
                                                <b>{ser_serie}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Emissão',
                                        width: 120,
                                        align: 'center',
                                        render: ({ ntf_dataemissao }) => (
                                            <div>
                                          <b>{!!ntf_dataemissao ? moment(ntf_dataemissao).format('DD/MM/YYYY') : ''}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Total Nota',
                                        width: 120,
                                        align: 'center',
                                        render: ({ valornotafiscal }) => (
                                            <div>
                                                <b>{FormatNumber(valornotafiscal, true)}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Cód. Produto',
                                        width: 120,
                                        align: 'right',
                                        render: ({ pro_codigo }) => (
                                            <div>
                                                <b>{pro_codigo}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Descrição',
                                        align: 'left',
                                        render: ({ pro_descricao }) => (
                                            <div>
                                                <b>{pro_descricao}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Un. Medida',
                                        align: 'left',
                                        render: ({ ump_id }) => (
                                            <div>
                                                <b>{ump_id}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Valor Unt. (R$)',
                                        width: 120,
                                        align: 'right',
                                        render: ({ nfi_valorunitario }) => (
                                            <div>
                                                <b>{FormatNumber(nfi_valorunitario, true)}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Saldo',
                                        align: 'right',
                                        width: 120,
                                        fixed: 'right',
                                        render: ({ saldo ,ump_casasdecimais}) => (
                                            <div>
                                                <b>{FormatarQuantidade(saldo, ump_casasdecimais)}</b>
                                            </div>
                                        ),
                                    }
                                ]} locale={{
                                    emptyText: (
                                        <Row>
                                            <Col span={24} className="p-t-b-8">
                                                <Divider orientation="center">
                                                    <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                                </Divider>
                                            </Col>
                                        </Row>
                                    )
                                }} scroll={{ x: 900 }} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}